/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';


import Svg from '../../../../widgets/Svg/Svg';

export default class SchoolDropDown extends React.Component {
    static get propTypes () {
        return {
            arrowRenderer: PropTypes.node,
            disabled: PropTypes.bool,
            school: PropTypes.object,
            name: PropTypes.string.isRequired,
            onChange: PropTypes.func.isRequired,
            options: PropTypes.array.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.onChange = this.onChange.bind(this);

        this.state = {selectedValue: {value: 'defaultOption', label: 'Select Institution'}};
    }

    onChange (selectedSchool) {
        this.setState({selectedValue: {value: selectedSchool.value, label: selectedSchool.label}});
        const schoolId = selectedSchool.value;

        this.props.onChange(schoolId);
    }

    arrowDown () {
        return (<span><Svg svgString="dropdown-open-18"/></span>);
    }

    render () {
        const dropDown = [];

        for (let i = 0; i < this.props.options.length; i++) {
            dropDown.push({
                value: this.props.options[i].schoolId,
                label: this.props.options[i].schoolName
            });
        }

        return (
            <Select arrowRenderer={this.props.arrowRenderer || this.arrowDown}
                backspaceRemoves={false}
                clearable={false}
                disabled={this.props.disabled}
                name={this.props.name}
                onChange={this.onChange}
                options={dropDown}
                searchable={false}
                value={this.state.selectedValue}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsComponents/InstitutionChangeComponent/SchoolDropDown.js